export const Conf={
	fileUri:'https://static.beertime.ge/'
}